module.exports = __webpack_public_path__ + "static/media/WalkingHeader.94fa0018.jpg";